var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({},_vm.$listeners),[_c('div',{staticClass:"normal-math-button-container"},[_c('span',[_vm._v(_vm._s(_vm.character))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }